var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center align-items-center",staticStyle:{"height":"500px","font-size":"15px","font-weight":"400","color":"#9A99A2"}},[_vm._v("\n  Данные отсутствуют\n")])}
var staticRenderFns = []

export { render, staticRenderFns }